import styled from 'styled-components';

import { DeleteButton } from 'components/specified-buttons';

export const StyledDeleteButton = styled(DeleteButton)`
  flex-shrink: 0;
  margin-top: 24px;
`;
